import { useState } from "react";

// ---- Set these to your real details --------------------------------------
const PHONE_DISPLAY = "+44 0773 723 0384";
const PHONE_TEL = "+447737230384"; // international format, used for the tap-to-call link
const WHATSAPP_NUMBER = "447737230384"; // digits only: country code + number, no "+" and no leading 0
const WHATSAPP_MESSAGE = "Hello Aquaviva Foods, I have a question about...";
const EMAIL = "aquavivafoodsuk@gmail.com";
// ---------------------------------------------------------------------------

const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function Icon({ children }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

const PinIcon = () => (
  <Icon>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </Icon>
);

const PhoneIcon = () => (
  <Icon>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </Icon>
);

const ChatIcon = () => (
  <Icon>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </Icon>
);

const MailIcon = () => (
  <Icon>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </Icon>
);

export default function Contact() {
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    setStatus("sending");

    try {
      // Same endpoint and fields as before
      const response = await fetch("https://formsubmit.co/aquavivafoodsuk@gmail.com", {
        method: "POST",
        body: new FormData(form),
      });

      if (response.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch (err) {
      // e.g. no internet connection: don't stay stuck on "Sending..."
      console.error("Contact form failed:", err);
      setStatus("error");
    }
  };

  return (
    <div className="page contact-page">
      <h2>Contact Us</h2>

      <p className="contact-intro">
        We'd love to hear from you. Whether you have questions about our products, delivery
        options, or partnerships, feel free to reach out.
      </p>

      <div className="contact-layout">
        <section className="contact-info" aria-label="Contact details">
          <div className="contact-card">
            <span className="contact-icon"><PinIcon /></span>
            <div>
              <h3>Our location</h3>
              <p>Manchester, United Kingdom</p>
            </div>
          </div>

          <div className="contact-card">
            <span className="contact-icon"><PhoneIcon /></span>
            <div>
              <h3>Call us</h3>
              <p><a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a></p>
            </div>
          </div>

          <div className="contact-card">
            <span className="contact-icon"><ChatIcon /></span>
            <div>
              <h3>WhatsApp</h3>
              <p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  Chat with us on WhatsApp
                </a>
              </p>
            </div>
          </div>

          <div className="contact-card">
            <span className="contact-icon"><MailIcon /></span>
            <div>
              <h3>Email us</h3>
              <p><a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
            </div>
          </div>
        </section>

        <section>
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Send us a message</h3>
            <p className="contact-form-note">
              Have a question or enquiry? We'll get back to you shortly.
            </p>

            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />

            <div className="ui-field">
              <label className="ui-label" htmlFor="contact-name">Your name</label>
              <input id="contact-name" type="text" name="name" placeholder="Enter your name" autoComplete="name" required />
            </div>

            <div className="ui-field">
              <label className="ui-label" htmlFor="contact-email">Your email</label>
              <input id="contact-email" type="email" name="email" placeholder="Enter your email" autoComplete="email" required />
            </div>

            <div className="ui-field">
              <label className="ui-label" htmlFor="contact-message">Your message</label>
              <textarea id="contact-message" name="message" placeholder="Write your message..." rows="5" required />
            </div>

            <button type="submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending..." : "Send message"}
            </button>

            {status === "success" && (
              <p className="success-msg" role="status">
                Thank you! Your message has been sent.
              </p>
            )}

            {status === "error" && (
              <p className="error-msg" role="alert">
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        </section>
      </div>
    </div>
  );
}